var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_143)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.99963,
    cy: 6.00006,
    rx: 5,
    ry: 5,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 12.25L9.63312 9.62852M11.0833 6.12502C11.0833 7.44005 10.5609 8.70123 9.63103 9.63109C8.70116 10.561 7.43999 11.0834 6.12496 11.0834C4.80993 11.0834 3.54876 10.561 2.61889 9.63109C1.68902 8.70123 1.16663 7.44005 1.16663 6.12502C1.16663 4.80999 1.68902 3.54882 2.61889 2.61895C3.54876 1.68908 4.80993 1.16669 6.12496 1.16669C7.43999 1.16669 8.70116 1.68908 9.63103 2.61895C10.5609 3.54882 11.0833 4.80999 11.0833 6.12502Z",
    stroke: "#748ADF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d2cb25832d832f886a20fe584a50fc1b.svg";
export { ForwardRef as ReactComponent };